<template>
  <a-modal width="480px" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('卖家账号')" prop="merchantAccount">
        <a-input v-model="form.merchantAccount" :maxLength="32" :placeholder="$t('请输入')+$t('卖家账号')+'（sid）'"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('店铺编号')" prop="merchantNo">
        <a-input v-model="form.merchantNo" :maxLength="32" :placeholder="$t('请输入')+$t('店铺编号')+'（）'"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('旺店通 API')" prop="appBaseUrl">
        <a-input v-model="form.appBaseUrl" :maxLength="255" placeholder="http://sandbox.wangdian.cn"/>
      </a-form-model-item>
      <a-form-model-item label="AppKey" prop="appKey">
        <a-input v-model="form.appKey" :maxLength="32" :placeholder="$t('请输入')+'AppKey'"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('接口秘钥')" prop="appSecret">
        <a-input-password v-model="form.appSecret" :maxLength="32" :placeholder="$t('请输入')+$t('接口秘钥')"/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('确定')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getMerchantWangDian, saveMerchantWangDian } from '@/api/merchant/merchantWangDian'

export default {
  name: 'WangDianForm',
  data () {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      formTitle: this.$t('旺店通配置'),
      open: false,
      form: {
        merchantId: null,
        merchantNo: undefined,
        merchantAccount: undefined,
        appBaseUrl: undefined,
        appKey: undefined,
        appSecret: undefined
      },
      rules: {
        merchantAccount: [
          { required: true, message: this.$t('卖家账号') + this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantNo: [
          { required: true, message: this.$t('店铺编号') + this.$t('不能为空'), trigger: 'blur' }
        ],
        appBaseUrl: [
          { required: true, message: this.$t('旺店通 API') + this.$t('不能为空'), trigger: 'blur' }
        ],
        appKey: [
          { required: true, message: 'AppKey' + this.$t('不能为空'), trigger: 'blur' }
        ],
        appSecret: [
          { required: true, message: this.$t('接口秘钥') + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.form = {
        merchantId: null,
        merchantNo: undefined,
        merchantAccount: undefined,
        appBaseUrl: undefined,
        appKey: undefined,
        appSecret: undefined
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    handleConfig (record) {
      this.reset()
      this.form.merchantId = record.id
      this.formTitle = this.$t('旺店通配置')
      getMerchantWangDian({ id: record.id }).then(response => {
        if (response.data) {
          this.form.merchantAccount = response.data.merchantAccount
          this.form.merchantNo = response.data.merchantNo
          this.form.appBaseUrl = response.data.appBaseUrl
          this.form.appKey = response.data.appKey
          this.form.appSecret = response.data.appSecret
        }
        this.open = true
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        saveMerchantWangDian(this.form).then(response => {
          if (response.code === '20001') {
            this.$message.success(this.$t('保存成功'), 3)
            this.open = false
            this.$emit('ok')
          }
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
